// extracted by mini-css-extract-plugin
export default {"input-size-container":"styles_input-size-container__4jVEf","input-size":"styles_input-size__kRFaW"};